<template>
  <div class="newsList">
    <div class="width1000  clearFix">
      <div class="news-item"
           v-for="(item,index) in dataList.data"
           :key="index">
        <div class="context">
          <div class="top">
            <!-- <a href="item.linkUrl"> -->
            <h3 class="title">{{item.title}}</h3>
            <!-- </a> -->
            <!-- <i class="el-icon-plus rotate"></i> -->
          </div>
          <div class="textWrap">
            <div class="imgWrap">
              <a v-if="item.tagDatas.length!=0?item.tagDatas[0].dataType=='article':''"
                 :href="'/h5/detail.html?artId='+item.tagDatas[0].dataVal"
                 target="_blank ">
                <img class="imgPic"
                     :src="item.tagDatas.length!=0?item.tagDatas[0].imgUrl:''" />
                <p class="imgText">{{item.tagDatas[0].title}}</p>
              </a>
              <a v-else
                 :href="item.tagDatas.length!=0?item.tagDatas[0].dataVal:''"
                 target="_blank ">
                <img class="imgPic"
                     :src="item.tagDatas.length!=0?item.tagDatas[0].imgUrl:''" />
                <p class="imgText">{{item.tagDatas.length!=0?item.tagDatas[0].title:''}}</p>
              </a>
            </div>
            <ul>
              <li v-for="(obj,idx) in item.tagDatas"
                  v-if="idx>0"
                  :key="idx">
                <a v-if="obj?obj.dataType=='article':''"
                   :href="'/h5/detail.html?artId='+obj.dataVal"
                   target="_blank ">{{obj.title}}</a>
                <a v-else
                   :href="obj.dataVal"
                   target="_blank ">{{obj.title}}</a>
              </li>

            </ul>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {

    }
  },
  props: ['dataList'],
  mounted () {

  },
  watch: {
    dataList (val) {

    }
  }
}
</script>
<style lang="less">
.newsList {
  margin-top: 15px;
  .news-item:nth-of-type(3n-1) {
    padding: 0 35px;
  }
  .news-item {
    float: left;
    margin-bottom: 15px;
    .context {
      width: 278px;
      height: 379px;
      padding: 15px;
      border: 1px solid #f5f5f5;
      margin: 0 auto;
      overflow: hidden;
      .top {
        position: relative;
        .title {
          font-size: 24px;
          font-family: 'Microsoft YaHei';
          border-bottom: 1px solid #f5f5f5;
          padding-bottom: 10px;
        }
        .title:hover {
          // color: #e60012;
        }
        .el-icon-plus {
          font-size: 18px;
          position: absolute;
          top: 0;
          right: 0;
          color: #666;
        }
        .rotate {
          transition: All 0.8s ease-in-out;
          -webkit-transition: All 0.8s ease-in-out;
          -moz-transition: All 0.8s ease-in-out;
          -o-transition: All 0.8s ease-in-out;
        }
        .el-icon-plus:hover {
          transform: rotate(180deg);
          -webkit-transform: rotate(180deg);
          -moz-transform: rotate(180deg);
          -o-transform: rotate(180deg);
          -ms-transform: rotate(180deg);
        }
      }
      .textWrap {
        padding-top: 15px;
        ul {
          li {
            height: 24px;
            padding: 0px 0 14px 0;
            line-height: 30px;
            overflow: hidden;
            a {
              font-size: 14px;
            }
          }
          li:hover a {
            color: #e60012;
          }
        }
        .imgWrap {
          position: relative;
          margin-bottom: 20px;
          height: 162px;
        }
        .imgPic {
          width: 100%;
          height: 100%;
        }
        .imgText {
          width: 100%;
          height: 35px;
          line-height: 35px;
          font-size: 14px;
          position: absolute;
          left: 0;
          bottom: 0;
          color: #fff;
          text-align: center;
          background-color: rgba(0, 0, 0, 0.6);
        }
      }
    }
  }
}
</style>
